import { render, staticRenderFns } from "./CopySequenceModal.vue?vue&type=template&id=633c2e18&scoped=true&"
import script from "./CopySequenceModal.vue?vue&type=script&lang=js&"
export * from "./CopySequenceModal.vue?vue&type=script&lang=js&"
import style0 from "./CopySequenceModal.vue?vue&type=style&index=0&id=633c2e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c2e18",
  null
  
)

export default component.exports